import React, { useState, useEffect } from "react";
import { Modal, Row } from "react-bootstrap";
import { Button } from "reactstrap";
import axiosConn from "config/axiosConn";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useAdminLoginMutation, useStateLoginMutation } from "../../redux/auth/authApi";
import CryptoJS from "crypto-js";
import axios from "axios";
import { userLoggedOut } from "../../redux/auth/authSlice";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { isCaptchaRelaxed } from "utils/captchaDemo";

const encryptPassword = (password) => {
  const secretKey = "EcoClubsForMissionLiFEAICTEADMIN1@1234SecretKey"; // Use a strong secret key for encryption
  const encryptedPassword = CryptoJS.AES.encrypt(
    password,
    secretKey
  ).toString();
  return encryptedPassword;
};
const generateToken = () => {
  const timestamp = Date.now();
  const secret = "EcoClubsForMissionLiFEAICTEADMIN1@1234SecretKey";
  const token = CryptoJS.AES.encrypt(`${timestamp}`, secret).toString();
  return token;
};

// Token validation function
const validateResponseToken = (responseToken, requestToken) => {
  //   alert("token is validations")
  //   console.log("crazy stuff is happening")
  try {
    const secret = "EcoClubsForMissionLiFEAICTEADMIN1@1234SecretKey";
    const decrypted = CryptoJS.AES.decrypt(responseToken, secret).toString(
      CryptoJS.enc.Utf8
    );
    const timestamp = parseInt(decrypted);

    // Check if token is tampered with
    if (isNaN(timestamp)) {
      return false;
    }

    // Check if token is expired (50 seconds)
    const currentTime = Date.now();
    const timeDifference = currentTime - timestamp;
    console.log(timeDifference, "timeDifference crazy stuff is happening");
    return timeDifference <= 50000 && responseToken === requestToken;
  } catch (error) {
    return false;
  }
};

const getApiErrorMessage = (payload, fallback = "Login failed!") => {
  return (
    payload?.error?.data?.message ||
    payload?.data?.message ||
    payload?.response?.data?.message ||
    payload?.error?.message ||
    payload?.message ||
    fallback
  );
};

// impoort {useSelector}

function AdminLoginModel() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [show, setShow] = useState(true);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [num1, setNum1] = useState(0);
  const [num2, setNum2] = useState(0);
  const [operator, setOperator] = useState("+");
  const [userInput, setUserInput] = useState("");
  const userData = useSelector((state) => state.auth.user);
  const [Adminlogin, { isSuccess: isAdminSuccess, error: adminError }] = useAdminLoginMutation();
  const [Statelogin, { isSuccess: isStateSuccess, error: stateError }] = useStateLoginMutation();
  const [captcha, setCaptcha] = useState("");
  const [captchaAnswer, setCaptchaAnswer] = useState("");
  const sanitizeUsername = (value) => value.replace(/[^A-Za-z0-9@._&-]/g, "").slice(0, 60);
  const sanitizeCaptchaInput = (value) => value.replace(/[^A-Za-z0-9]/g, "").slice(0, CAPTCHA_LENGTH);

  const CAPTCHA_LENGTH = 6;

  const renderCaptcha = (captchaObj) => (
    <img src={captchaObj?.image} alt="captcha" style={{ height: "50px", borderRadius: "6px" }} />
  );

  const Logout = async () => {
    try {
      const makeLogout = await fetch(`https://ecoclubs.education.gov.in/api/logout`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      });
      if (makeLogout.ok) {
        //  toast.success("Logout Successfully");
      }
    } catch (error) {
      toast.error("Logout Failed");
      console.log(error);
    }
    dispatch(userLoggedOut());
  };

  // useEffect(() => {
  //     // console.log("userData3",userData)
  //     if (isSuccess) {

  //               toast.success("Logged in successfully!");
  //               localStorage.setItem("isLogin", true);
  //             setShow(false);
  //             // handleViewexit();
  //             navigate("/admin");
  //     }
  //     if (error) {
  //         console.log(error)
  //         // toast.error(error.data.message)
  //       if ("data" in error) {
  //         // alert("hello")
  //         const errorData = error ;
  //         // console.log("errordata",errorData)
  //         toast.error(errorData.data.message);
  //         fetchCaptcha();
  //       }
  //     }
  //     // if(userData.name!=='' && userData){
  //     //     navigate('/')
  //     // }
  //     // generateCaptcha();
  // }, [userData,isSuccess,error]);

  const generateCaptcha = async () => {
    try {
      const response = await axiosConn("get", "captcha");
      setCaptcha(response?.data?.captcha || {});
      setCaptchaAnswer("");
    } catch (error) {
      toast.error("Failed to load CAPTCHA");
    }
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  // const performLogin = async (postData, expectedToken) => {
  //   const result = await login(postData);
  //   if (!result?.data?.success) throw result;

  //   if (!validateResponseToken(result.data.authToken, expectedToken)) {
  //     throw new Error("Invalid or expired token in response");
  //   }

  //   return result.data;
  // };


  const handleLoginError = async (error) => {
    toast.error(getApiErrorMessage(error, "Login failed"));
    await Logout();
    setUsername("");
    setPassword("");
    generateCaptcha();
  };



  const handleAdminLogin = async (postData) => {
    console.log('inside the admin login', postData);
    console.log('USERNAME CHECK:', postData.username);
    try {
      const expectedToken = postData.authToken;
      const result = await Adminlogin(postData, expectedToken);
      if (result?.data?.success) {
        toast.success("Logged in successfully!");
        localStorage.setItem("isLogin", true);
        // Ras Activity admin redirect (case-insensitive check - now checks if username CONTAINS "rasadmin")
        const username = postData.username ? postData.username.trim().toLowerCase() : "";
        console.log('TRIMMED USERNAME:', username);
        if (username.includes("rasadmin")) {
          console.log("✅ RASADMIN detected! Redirecting to RAS Activity Admin...");
          localStorage.setItem("adminType", "rasadmin");
          setShow(false);
          // Use navigate with replace to prevent back button issues
          navigate("/ras-activity-admin", { replace: true });
          return;
        } else {
          console.log("❌ Not rasadmin, navigating to Environment Day Dashboard");
          localStorage.setItem("adminType", "central");
          navigate("/admin/environment-day-dashboard");
        }
        setShow(false);
      } else {
        toast.error(getApiErrorMessage(result, "Login failed!"));
        generateCaptcha();
        await Logout();
        setUsername("");
        setPassword("");
      }
    } catch (error) {
      handleLoginError(error);
    }
  };


  const handleStateAdminLogin = async (postData) => {
    console.log('inside the state admin login', postData);
    try {
      const expectedToken = postData.authToken;
      const data = await Statelogin(postData, expectedToken);

      const stateMap = {
        'andhrapradesh': 'ANDHRA PRADESH',
        'arunachalpradesh': 'ARUNACHAL PRADESH',
        'assam': 'ASSAM',
        'bihar': 'BIHAR',
        'chhattisgarh': 'CHHATTISGARH',
        'goa': 'GOA',
        'gujarat': 'GUJARAT',
        'haryana': 'HARYANA',
        'himachalpradesh': 'HIMACHAL PRADESH',
        'jammu&kashmir': 'JAMMU & KASHMIR',
        'jharkhand': 'JHARKHAND',
        'karnataka': 'KARNATAKA',
        'kerala': 'KERALA',
        'madhyapradesh': 'MADHYA PRADESH',
        'maharashtra': 'MAHARASHTRA',
        'manipur': 'MANIPUR',
        'meghalaya': 'MEGHALAYA',
        'mizoram': 'MIZORAM',
        'nagaland': 'NAGALAND',
        'odisha': 'ODISHA',
        'punjab': 'PUNJAB',
        'rajasthan': 'RAJASTHAN',
        'sikkim': 'SIKKIM',
        'tamilnadu': 'TAMILNADU',
        'telangana': 'TELANGANA',
        'tripura': 'TRIPURA',
        'uttarakhand': 'UTTARAKHAND',
        'uttarpradesh': 'UTTAR PRADESH',
        'westbengal': 'West Bengal',
        'delhi': 'DELHI',
        'andaman&nicobarislands': 'ANDAMAN & NICOBAR ISLANDS',
        'chandigarh': 'CHANDIGARH',
        'damananddiu': 'DADRA & NAGAR HAVELI AND DAMAN & DIU',
        'lakshadweep': 'LAKSHADWEEP',
        'puducherry': 'Puducherry',
        'kvs': 'KENDRIYA VIDYALAYA SANGHATHAN',
        'nvs': 'NAVODAYA VIDYALAYA SAMITI',
        'ladakh': 'LADAKH',
      };

      const stateKey = postData.username.toUpperCase().startsWith('EC4ML_')
        ? postData.username.split('_')[1].toLowerCase()
        : '';
      console.log(stateKey, "stateKey");
      const stateValue = stateMap[stateKey] || null;

      if (stateValue) {
        localStorage.setItem("stateAdminState", stateValue);
        localStorage.setItem("adminType", "state");
        navigate("/admin/environment-day-dashboard", { state: { stateValue } });
      } else {
        throw new Error("Unknown state admin username");
      }

      if (data?.data?.success) {

        toast.success("Logged in successfully!");
        localStorage.setItem("isLogin", true);
        setShow(false);
      } else {
        // alert("hello")
        toast.error(getApiErrorMessage(data, "Login failed!"));
        generateCaptcha();
        await Logout();
        // setCaptchaAnswer(''); // Clear previous answer
        // setUserInput('')
        setUsername("");
        setPassword("");
      }
    } catch (error) {
      handleLoginError(error);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!isCaptchaRelaxed() && (!captcha || !captchaAnswer || captchaAnswer.length < CAPTCHA_LENGTH)) {
      toast.error("Please complete the CAPTCHA");
      return;
    }
    const authToken = generateToken();
    const encryptedPassword = encryptPassword(password);

    const isStateAdmin = username?.toUpperCase().startsWith("EC4ML_");

    const postData = {
      username,
      password: encryptedPassword,
      role: isStateAdmin ? 4 : 1,
      authToken,
      captchaId: captcha?.captchaId,
      captchaAnswer,
    };

    if (isStateAdmin) {
      await handleStateAdminLogin(postData);
    } else {
      await handleAdminLogin(postData);
    }
  };



  return (
    // <Modal show={show} onHide={() => { setShow(false); handleViewexit() }} className='loginmodal'>
    //     <Modal.Body>
    <div className="popup-login-signup adminlogin">
      <div className="login-box">
        <h3 className="text-center">ADMIN LOGIN</h3>
        <button
          type="button"
          className="popup-close-btn"
          onClick={() => {
            setShow(false);
          }}
        >
          X
        </button>
        <form onSubmit={handleLogin}>
          <div className="form-group mt-3">
            <label htmlFor="username" className="label-text">
              User Name
            </label>
            <input
              name="username"
              autocomplete="off"
              type="text"
              className="form-input form-control"
              placeholder="User Name"
              value={username}
              onChange={(e) => {
                const value = sanitizeUsername(e.target.value);
                if (value.length <= 60) {
                  setUsername(value);
                }
              }}
              required
            />
          </div>
          <div className="form-group mt-3" style={{ position: "relative" }}>
            <label htmlFor="password" className="label-text">
              Password
            </label>
            <input
              name="password"
              autocomplete="off"
              type={showPassword ? "text" : "password"}
              placeholder="password"
              className="form-input form-control"
              value={password}
              onChange={(e) => {
                if (e.target.value.length <= 64) {
                  setPassword(e.target.value);
                }
              }}
              required
            />
            <span
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: "absolute",
                right: "15px",
                bottom: "10px",
                cursor: "pointer",
                zIndex: 10,
              }}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <div className="form-group mt-3">
            {/* <label>CAPTCHA</label> */}

            <div className="captcha-container">
              {renderCaptcha(captcha)}
              <div className="captcha-controls">
                <input
                  type="text"
                  value={captchaAnswer}
                  onChange={(e) => setCaptchaAnswer(sanitizeCaptchaInput(e.target.value))}
                  placeholder="Enter the code"
                  maxLength={CAPTCHA_LENGTH}
                  autoComplete="off"
                />
                <button
                  type="button"
                  className="captcha-refresh"
                  onClick={generateCaptcha}
                  title="Refresh CAPTCHA"
                >
                  ↻
                </button>
              </div>
            </div>
          </div>

          <div className="form-group mt-3">
            <Button type="submit" className="button green btn-login-signup">
              Submit
            </Button>
          </div>
        </form>
      </div>
    </div>
    //     </Modal.Body>
    // </Modal>
  );
}

export default AdminLoginModel;